<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 22.94 35.08" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linejoin="round"><rect height="13.87" rx="1.5" width="3.27" x="3.39" y="20.71"/><rect height="13.87" rx="1.5" width="3.27" x="19.17" y="20.71"/><path d="m.5.5v9.37a1.79 1.79 0 0 0 1.79 1.79h5.28a1.79 1.79 0 0 0 1.79-1.79v-9.37" stroke-linecap="round"/><path d="m4.93.5v20.21" stroke-linecap="round"/><path d="m22.44 26.1v-25.6h-2.61a3.35 3.35 0 0 0 -3.35 3.35v9.58a3.34 3.34 0 0 0 3.25 3.34l2.72.09"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
